import styled, { css } from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';

export const BusinessPageCustom = styled.div`
  position: relative;
  box-sizing: border-box;
  margin: 0 auto;
  padding: 0 0 60px;
  background-color: ${({ theme }) => theme.palette.primary.background};
  color: ${({ theme }) => theme.palette.primary.labels};
  width: 100%;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 0;
    margin: 0 0 40px;
    width: 100%;
    border-radius: 0;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    margin: 0;
  }
`;

export const BusinessPageHeader = styled.div<{
  $topMargin?: boolean;
}>`
  text-align: center;
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 15px;

  @media (max-width: ${({ theme }) =>
      theme.breakpoints.lg}) and (min-width: 950px) {
    font-size: 28px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    font-size: 26px;
    font-weight: 500;
  }

  ${({ $topMargin }) =>
    $topMargin &&
    css`
      margin: 70px auto 60px;
    `}
`;

export const BusinessPageTitle = styled(Typography.Title)`
  font-size: 32px;
`;

export const BusinessPageButton = styled(Typography.Text)`
  display: none;
  justify-content: center;
  align-items: center;
  text-align: center;
  border-radius: 14px;
  background: ${({ theme }) => theme.palette.brand.main};
  padding: 15px 35px;
  color: ${({ theme }) => theme.palette.system.white};
  margin: 20px 15px 0;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    display: flex;
    width: 350px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    width: 100%;
  }
`;

export const BusinessPageDescription = styled.div`
  margin-top: 20px;
  font-size: 18px;
  font-weight: 400;
  max-width: 500px;

  @media (max-width: ${({ theme }) =>
      theme.breakpoints.lg}) and (min-width: 950px) {
    font-size: 16px;
    margin-top: 15px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    font-size: 15px;
    font-weight: 400;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    width: calc(100% - 30px);
  }
`;

export const BusinessPageFormsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 40px;
  border-radius: 32px;
  background: ${({ theme }) => theme.palette.secondary.background};
  max-width: 1280px;
  margin: 140px auto 0;
  padding: 60px;

  @media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
    margin: 80px 40px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    margin: 80px 0;
    padding: 60px 40px;
    flex-direction: column-reverse;
    align-items: center;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    margin: 80px 0;
    padding: 60px 15px;
  }
`;
